import {
    CASH_REGISTER_TICKET_REQUEST,
    CASH_REGISTER_TICKET_RECEIVE,
    CASH_REGISTER_TICKET_RECEIVE_ERROR,
    CASH_REGISTER_OPEN_CR_REQUEST,
    CASH_REGISTER_OPEN_CR_RECEIVE,
    CASH_REGISTER_OPEN_CR_RECEIVE_ERROR,
    CASH_REGISTER_OPEN_REQUEST,
    CASH_REGISTER_OPEN_RECEIVE,
    CASH_REGISTER_OPEN_RECEIVE_ERROR,
    CASH_REGISTER_REQUEST,
    CASH_REGISTER_RECEIVE,
    CASH_REGISTER_RECEIVE_ERROR,
    CASH_REGISTER_CHECK_IN_RECEIVE,
    CASH_REGISTER_LEAVE_CURRENT,
    CASH_REGISTER_CLOSE_REQUEST,
    CASH_REGISTER_CLOSE_RECEIVE,
    CASH_REGISTER_CLOSE_RECEIVE_ERROR,
    CASH_REGISTER_CLOSED_CR_REQUEST,
    CASH_REGISTER_CLOSED_CR_RECEIVE,
    CASH_REGISTER_CLOSED_CR_RECEIVE_ERROR,
    CASH_REGISTER_CLOSE_TICKET,
    CASH_REGISTER_CHECK_OUT_RECEIVE
} from "../config/actions";

let defaultState = {
    ticket: false,
    ticketLoading: true,
    ticketNotFound: false,
    openCashRegisters: [],
    cashRegister: false,
    cashRegisterLoading: true,
    closedCashRegisters: [],
    closedCashRegistersLoading: true
};

const cashRegisterReducer = (state = defaultState, action) => {
    switch (action.type) {
        case CASH_REGISTER_TICKET_REQUEST:
            return Object.assign({}, state, {
                ticket: false,
                ticketLoading: true,
                ticketNotFound: false
            });
        case CASH_REGISTER_TICKET_RECEIVE:
            return Object.assign({}, state, {
                ticket: action.data,
                ticketLoading: false,
                ticketNotFound: false
            });
        case CASH_REGISTER_TICKET_RECEIVE_ERROR:
            return Object.assign({}, state, {
                ticket: false,
                ticketLoading: false,
                ticketNotFound: true
            });
        case CASH_REGISTER_OPEN_CR_REQUEST:
            return Object.assign({}, state, {
                cashRegisterLoading: true
            });
        case CASH_REGISTER_OPEN_CR_RECEIVE:
            return Object.assign({}, state, {
                cashRegisterLoading: false,
                openCashRegisters: action.data
            });
        case CASH_REGISTER_OPEN_CR_RECEIVE_ERROR:
            return Object.assign({}, state, {
                cashRegisterLoading: false,
                openCashRegisters: []
            });
        case CASH_REGISTER_OPEN_REQUEST:
            return Object.assign({}, state, {
                cashRegisterLoading: true
            });
        case CASH_REGISTER_REQUEST:
            return Object.assign({}, state, {
                cashRegisterLoading: true
            });
        case CASH_REGISTER_RECEIVE:
            return Object.assign({}, state, {
                cashRegisterLoading: false,
                cashRegister: action.data
            });
        case CASH_REGISTER_RECEIVE_ERROR:
            return Object.assign({}, state, {
                cashRegisterLoading: false,
                cashRegister: false
            });
        case CASH_REGISTER_CHECK_IN_RECEIVE:
            return Object.assign({}, state, {
                ticket: false,
                ticketLoading: false,
                ticketNotFound: false
            });
        case CASH_REGISTER_CHECK_OUT_RECEIVE:
            return Object.assign({}, state, {
                ticket: false,
                ticketLoading: false,
                ticketNotFound: false
            });
        case CASH_REGISTER_LEAVE_CURRENT:
            return Object.assign({}, state, {
                cashRegisterLoading: false,
                cashRegister: false
            });
        case CASH_REGISTER_CLOSE_REQUEST:
            return Object.assign({}, state, {
                cashRegisterLoading: true
            });
        case CASH_REGISTER_CLOSE_RECEIVE:
            return Object.assign({}, state, {
                cashRegister: false,
                cashRegisterLoading: false,
            });
        case CASH_REGISTER_CLOSE_RECEIVE_ERROR:
            return Object.assign({}, state, {
                cashRegisterLoading: false
            });
        case CASH_REGISTER_CLOSED_CR_REQUEST:
            return Object.assign({}, state, {
                closedCashRegisters: [],
                closedCashRegistersLoading: true
            });
        case CASH_REGISTER_CLOSED_CR_RECEIVE:
            return Object.assign({}, state, {
                closedCashRegisters: action.data,
                closedCashRegistersLoading: false
            });
        case CASH_REGISTER_CLOSED_CR_RECEIVE_ERROR:
            return Object.assign({}, state, {
                closedCashRegisters: [],
                closedCashRegistersLoading: false
            });
        case CASH_REGISTER_CLOSE_TICKET:
            return Object.assign({}, state, {
                ticket: false
            });
        default:
            return state;
    }
};

export default cashRegisterReducer;